<template>
  <section class="management-section" data-testid="management-deep-dive">
    <ManagementSectionHeader :title="$t('UserProjects.management.deepDive.title')" />

    <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
      <button
        v-for="action in actions"
        :key="action.id"
        type="button"
        class="management-deep-dive-card flex items-center gap-2 px-4 py-3 text-left transition-colors hover:bg-[#FAFAFA]"
        :data-testid="`management-deep-dive-${action.id}`"
        @click="$emit('navigate', action.route)"
      >
        <i :class="[action.icon, 'text-base shrink-0 text-[var(--color-disabled)]']" />
        <span class="text-xs font-medium text-[var(--color-dark)]">{{ action.label }}</span>
      </button>
    </div>
  </section>
</template>

<script>
import ManagementSectionHeader from '@/components/CustomerApp/UserProjects/ManagementSectionHeader.vue';

export default {
  name: 'ManagementDeepDiveActions',
  components: { ManagementSectionHeader },
  emits: ['navigate'],
  computed: {
    actions() {
      return [
        {
          id: 'overview',
          label: this.$t('UserProjects.management.deepDive.switchProject'),
          icon: 'pi pi-briefcase',
          route: '/user-projects/overview',
        },
        {
          id: 'decisions',
          label: this.$t('UserProjects.management.deepDive.decisions'),
          icon: 'pi pi-check-square',
          route: '/user-projects/decisions',
        },
        {
          id: 'constraints',
          label: this.$t('UserProjects.management.deepDive.constraints'),
          icon: 'pi pi-exclamation-triangle',
          route: '/user-projects/constraints',
        },
        {
          id: 'milestones',
          label: this.$t('UserProjects.management.deepDive.milestones'),
          icon: 'pi pi-flag',
          route: '/user-projects/milestones',
        },
      ];
    },
  },
};
</script>

<style scoped>
@import './management-section.css';

.management-deep-dive-card {
  background: var(--color-white);
  border: 1px solid var(--color-light-grey);
  border-radius: 10px;
}
</style>
